import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { HbmIframeService } from '../../../services/hbm/hbm-iframe.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';
import { TunnelNavigationStore } from '../../../stores/tunnel/tunnel-navigation.store';
import { TunnelDataStore } from '../../../stores/tunnel/tunnel-data.store';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { KitchenConfigurationData } from '../../../stores/tunnel/model/configuration-data/kitchen-configuration-data';

@Component({
  selector: 'ng-casto-kitchen-recap',
  templateUrl: './recap.component.html',
})
export class KitchenRecapComponent implements OnInit {
  @Output() onBackToStep: EventEmitter<number> = new EventEmitter();

  public currentStyle;
  public currentModel;
  public currentLayout;
  public currentOvenConfiguration;
  public currentFridgeConfiguration;

  constructor(
    public current: CurrentService,
    public gtm: GTM,
    public datas: DatasService,
    private readonly byMe: HbmIframeService,
    private readonly router: Router,
    private readonly customer: CustomerService,
    private readonly tunnelNavigationStore: TunnelNavigationStore,
    private readonly tunnelDataStore: TunnelDataStore
  ) {
    if (current.kitchen.styleId > 0) {
      this.currentStyle = datas.styles.find(s => s.id === this.current.kitchen.styleId);
    }

    if (current.kitchen.modelId > 0) {
      this.currentModel = datas.models.find(m => m.id === this.current.kitchen.modelId);
    }

    if (current.kitchen.layoutRef) {
      this.currentLayout = datas.layouts.find(l => l.id === this.current.kitchen.layoutRef);
    }

    if (current.kitchen.ovenConfigurationRef) {
      this.currentOvenConfiguration = datas.ovenConfigurations.find(
        oc => oc.id === this.current.kitchen.ovenConfigurationRef
      );
    }

    if (current.kitchen.fridgeConfigurationRef) {
      this.currentFridgeConfiguration = datas.fridgeConfigurations.find(
        fc => fc.id === this.current.kitchen.fridgeConfigurationRef
      );
    }
  }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/synthese`, 'Cuisine | Choix', {
      stepNumber: 6,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
  }

  backToStep(step: number) {
    this.onBackToStep.emit(step);
  }

  private prepareKitchenByme() {
    this.byMe.prepareKitchenBymeSettings(
      this.current.kitchen.modelId,
      this.current.kitchen.layoutRef,
      this.current.kitchen.ovenConfigurationRef,
      this.current.kitchen.fridgeConfigurationRef
    );
  }

  start() {
    this.saveKitchenInspiration();
    this.prepareKitchenByme();
  }

  private saveKitchenInspiration() {
    this.tunnelDataStore.updateConfigurationData(CONFIG_CONTEXT.KITCHEN, {
      inspiration: this.current.kitchen,
    } as KitchenConfigurationData);
  }

  startVendor() {
    this.saveKitchenInspiration();
    this.prepareKitchenByme();
    this.tunnelNavigationStore.nextStep();
  }
}
